import { useTranslation } from 'react-i18next'

interface Props {
	type: 'vehicle' | 'hvac' | 'inverter'
}

export const getLinkEnodeData = ({ type }: Props) => {
	const { t } = useTranslation('pages_enodeInit', { keyPrefix: 'linkEnode' })

	switch (type) {
		case 'vehicle':
			return {
				label: t('otsikkoAuto'),
				link: 'https://developers.enode.com/api/capabilities/vehicles',
				image: './assets/electric-car.png',
				description: {
					text1: t('kuvausAuto'),
					compatibility: t('tarkistaAuto'),
				},
				buttonText: t('lisaaAuto'),
			}
		case 'inverter':
			return {
				label: t('otsikkoPaneeli'),
				link: 'https://developers.enode.com/api/capabilities/inverters',
				image: './assets/solar-panel.png',
				description: {
					text1: t('kuvausPaneeli'),
					compatibility: t('tarkistaPaneeli'),
				},
				buttonText: t('lisaaPaneeli'),
			}
		case 'hvac':
			return {
				label: t('otsikkoHvac'),
				link: 'https://developers.enode.com/api/capabilities/hvacs',
				image: './assets/hvac.png',
				description: {
					text1: t('kuvausHvac1'),
					text2: t('kuvausHvac2'),
					compatibility: t('tarkistaHvac'),
				},
				buttonText: t('lisaaHvac'),
			}
	}
}
